<template>
  <el-row>
    <div class="mb-10px" v-if="$parent.$options.name !== 'ElDialog'">
      <span
        class="border-l-3 border-color-primary pl-10px text-18px"
        v-if="operateType !== 'read' && operateType !== 'action'"
        >{{ $t('基本信息') }}</span
      >
      <el-page-header v-else @back="$emit('back')" :content="$t('基本信息')"></el-page-header>
    </div>
    <el-form
      :model="formData"
      ref="formRef"
      label-width="150px"
      :disabled="isAllDisAbled"
      :rules="formRules"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item :label="`${$t('违章描述')}`" prop="description">
            <el-autocomplete
              v-model="formData.description"
              :disabled="IsDisable('description')"
              :fetch-suggestions="querySearch"
              :placeholder="`${$t('请输入')}`"
              style="width: 100%;"
              :trigger-on-focus="false"
              @select="handleSelect"
              type="textarea"
              :maxlength="500"
              show-word-limit
              :autosize="{ minRows: 2 }"
            >
              <template slot-scope="{ item }">
                <div>{{ item.description }}</div>
              </template>
            </el-autocomplete>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item :label="`${$t('违章地点')}`" prop="areaId">
            <el-select
              v-model="formData.areaId"
              :disabled="IsDisable('areaId')"
              size="small"
              style="width: 100%;"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in riskList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="`${$t('违章时间')}`" prop="violationTime">
            <el-date-picker
              :disabled="IsDisable('violationTime')"
              size="small"
              v-model="formData.violationTime"
              style="width: 100%;"
              class="w-full"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="发生时间"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="`${$t('违章类型')}`" prop="typeId">
            <el-select
              v-model="formData.typeId"
              size="small"
              :placeholder="`${$t('违章类型')}`"
              :disabled="IsDisable('typeId')"
              style="width: 100%;"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in typeList"
                :key="index"
                :label="item.displayName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item :label="`${$t('违章级别')}`" prop="levelId">
            <el-select
              v-model="formData.levelId"
              size="small"
              :placeholder="`${$t('违章类型')}`"
              :disabled="IsDisable('levelId')"
              style="width: 100%;"
              clearable
              filterable
            >
              <el-option
                v-for="(item, index) in levelList"
                :key="index"
                :label="item.displayName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="`${$t('违章单位')}`" prop="orgId">
            <el-select
              size="small"
              style="width: 100%;"
              v-model="formData.orgId"
              :disabled="IsDisable('orgId')"
              placeholder="请选择"
              clearable
              filterable
            >
              <el-option
                v-for="item in departmentList"
                :key="item.id"
                :label="item.displayName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="`${$t('违章人员')}`" prop="violators">
            <div class="flex">
              <el-input
                size="small"
                v-model="formData.violators"
                :disabled="IsDisable('violators')"
                readonly
                placeholder="请选择"
                style="flex:1"
              >
                <template slot="append">
                  <el-button :disabled="IsDisable('violators')" @click="showSelectDialog = true"
                    >选择</el-button
                  >
                </template>
              </el-input>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item :label="`${$t('上报人')}`" prop="reportPersonName">
            <el-input size="small" v-model="formData.reportPersonName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="`${$t('上报单位')}`" prop="reportPersonOrgId">
            <el-select
              size="small"
              style="width: 100%;"
              v-model="formData.reportPersonOrgId"
              :disabled="ownDepartment.length < 2"
              placeholder="请选择"
              filterable
            >
              <el-option
                v-for="item in ownDepartment"
                :key="item.orgId"
                :label="item.name"
                :value="item.orgId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="`${$t('上报时间')}`" prop="reportTime">
            <el-date-picker
              size="small"
              v-model="formData.reportTime"
              style="width: 100%;"
              class="w-full"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="`${$t('是否关联积分')}`"
            prop="associateIntegral"
            :rules="[
              {
                required: true,
                message: `请选择`,
                trigger: ['change', 'blur'],
              },
            ]"
          >
            <el-switch
              v-model="formData.associateIntegral"
              :disabled="IsDisable('description')"
              @change="associateIntegralChange"
            ></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            v-if="formData.associateIntegral"
            label="分值"
            prop="integral"
            :rules="[
              {
                required: true,
                message: `请选择`,
                trigger: ['change', 'blur'],
              },
            ]"
          >
            <el-select v-model="formData.integral" class="w-full" size="small" placeholder="请选择">
              <el-option
                v-for="item in integralsList"
                :key="item.code"
                :label="item.displayName"
                :value="Number(item.code)"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item :label="`${$t('违章图片')}`" prop="pictures">
            <uploadCom
              ref="uploadCom"
              :fileTypeList="fileTypeList"
              @update:file="updateFile"
              :fileMaxSize="20"
              :fileNum="9"
              :disabled="IsDisable('pictures')"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <PersonManySelect
      :visible.sync="showSelectDialog"
      :selectedPersonList="personList"
      v-if="showSelectDialog"
      @getSelectedList="getPersonList"
    />
  </el-row>
</template>
<script>
import uploadCom from '@/components/safety/WizSafetyPage/safetyFactor/uploadCom'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import { OrganizationApi, EafProfileApi } from '@wiz-api/account'
import { ViolationStandardApi } from '@wiz-api/personnel-safety-management'
import { AreaApi } from '@wiz-api/area-management'
import dayjs from 'dayjs'
import { violatedBasicInfoProps } from '@/components/safety/WizSafetyPage/violation/enums'

const violationStandardApi = new ViolationStandardApi()
const eafProfileApi = new EafProfileApi()
const organizationApi = new OrganizationApi()
const dataCategoryApi = new DataCategoryApi()
const areaApi = new AreaApi()
const PersonManySelect = () => {
  return import('@/components/safety/WizSafetyPage/safetyFactor/SelectPeople')
}

export default {
  name: 'violation-info-command',
  components: { uploadCom, PersonManySelect },
  props: {
    propsKey: {
      type: String,
      default: '',
    },
    operateType: {
      default: '',
      type: String,
    },
    operateData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  computed: {},
  data() {
    return {
      integralsList: [
        {
          code: '0.5',
          displayName: '0.5分',
        },
        {
          code: '1',
          displayName: '1分',
        },
        {
          code: '3',
          displayName: '3分',
        },
        {
          code: '6',
          displayName: '6分',
        },
        {
          code: '9',
          displayName: '9分',
        },
        {
          code: '12',
          displayName: '12分',
        },
      ],
      fileTypeList: ['jpg', 'jpeg', 'png', 'bmp'],
      formData: {
        integral: '',
        associateIntegral: true,
        description: '',
        areaId: undefined,
        areaName: '',
        violationTime: '',
        typeId: '',
        levelId: '',
        orgId: '',
        orgName: '',
        violators: undefined,
        pictures: '',
        reportPersonId: '',
        reportPersonName: '',
        reportPersonOrgId: '',
        reportPersonOrgName: '',
        reportTime: '',
        isSubmit: false,
      },
      formRules: {},
      accidentType: [],
      showSelectDialog: false,
      typeList: [],
      levelList: [],
      riskList: [],
      departmentList: [],
      ownDepartment: [],
      isAble: [],
      personList: [],
      restaurants: [],
      isAllDisAbled: false,
      isAllAble: true,
    }
  },
  mounted() {
    if (this.operateType === 'create') {
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      const data = userInfo?.profile || {}
      this.formData.reportPersonName = data.given_name
      this.formData.reportPersonId = data.sub
      this.formData.reportTime = new Date()
      this.formData.violationTime = new Date()
    }
  },
  created() {
    this.initData()
    this.getRegulationType()
    this.getDepartmentList()
    this.getUserInfo()
    this.getRiskData()
    this.getStandardList()
  },
  methods: {
    associateIntegralChange(val) {
      if (val) {
        this.formData.integral = ''
      }
    },
    // 详情回显
    detailShow(data) {
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = data[key]
        if (key === 'violators' && data[key]) {
          this.getPersonList(JSON.parse(data[key]))
        }
      })
      if (this.formData.integral === 0) {
        this.formData.integral = ''
      }
      this.ownDepartment = [{ name: data.reportPersonOrgName, orgId: data.reportPersonOrgId }]
      this.$nextTick(() => {
        this.formData.pictures && this.$refs.uploadCom?.setFile(JSON.parse(this.formData.pictures))
      })
    },
    // 是否可编辑
    IsDisable(prop) {
      if (this.isAllDisAbled) {
        return true
      }
      if (this.isAllAble) {
        return false
      }
      return !this.isAble.includes(prop)
    },
    // 违章描述筛选
    handleSelect(item) {
      this.formData.description = item.description
      this.formData.typeId = item.typeId
      this.formData.levelId = item.levelId
    },
    /**
     * @description 违章标准列表查询
     */
    async getStandardList() {
      const params = {
        maxResultCount: 999,
        skipCount: 0,
        sorting: 'CreationTime DESC',
      }
      const [err, res] = await violationStandardApi.getList({ body: params })
      if (err) return
      this.restaurants = res.items
    },
    async querySearch(queryString, cb) {
      const restaurants = this.restaurants
      const results = queryString
        ? restaurants.filter((item) => {
            return item.description.indexOf(queryString) >= 0
          })
        : restaurants
      cb(results)
    },
    // 文件显示
    updateFile(val) {
      if (val.length) {
        this.formData.pictures = JSON.stringify(val)
      } else {
        this.formData.pictures = ''
      }
    },
    getPersonList(personList) {
      this.personList = personList.map((item) => {
        return {
          name: item.name,
          id: item.id,
          keyId: item.keyId,
        }
      })
      this.formData.violators = this.personList.reduce((pre, cur, index) => {
        pre += cur.name + (index === this.personList.length - 1 ? '' : ',')
        return pre
      }, '')
    },
    initData() {
      const formRules = {}
      const self = this
      violatedBasicInfoProps[this.propsKey].isMustReq.forEach((item) => {
        formRules[item] = [
          { required: true, message: self.$t('请输入'), trigger: ['blur', 'change'] },
        ]
      })
      this.isAllAble = violatedBasicInfoProps[this.propsKey].isAllAble
      this.isAllDisAbled = violatedBasicInfoProps[this.propsKey].isDisAbled
      this.isAble = violatedBasicInfoProps[this.propsKey].isAble
      this.formRules = formRules
    },
    // 从数据字典
    async getRegulationType() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['ViolationType', 'ViolationLevel'],
        includeDetails: true,
      })
      if (err) return
      const ViolationType = res.find((item) => {
        return item.code === 'ViolationType'
      })
      this.typeList = ViolationType?.dataItems || []
      const ViolationLevel = res.find((item) => {
        return item.code === 'ViolationLevel'
      })
      this.levelList = ViolationLevel?.dataItems || []
    },
    // 获取风险区域列表列表数据
    async getRiskData() {
      const data = {
        maxResultCount: 999, // 每页多少条
        skipCount: 0,
      }
      const [err, res] = await areaApi.getList(data)
      if (!err) {
        this.riskList = res.items
      }
    },
    /**
     * @description 部门列表查询
     */
    async getDepartmentList() {
      const [err, res] = await organizationApi.getList({
        sorting: '', // 排序
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.departmentList = res.items
      }
    },
    // 获取当前用户信息
    async getUserInfo() {
      if (this.$route.query.id) return
      const [err, res] = await eafProfileApi.getCurrentUserEafProfile()
      if (!err) {
        this.ownDepartment = res.organizationUnits || []
        if (this.ownDepartment.length === 1 && this.operateType === 'create') {
          this.formData.reportPersonOrgId = res.organizationUnits[0].orgId
        }
      }
    },
    changePersonSelect() {},
    async submitData() {
      await this.$refs.formRef.validate()
      const params = {
        ...this.formData,
        integral: this.formData.integral ? this.formData.integral : 0,
      }
      params.violators = params.violators && JSON.stringify(this.personList)
      const areaObj = this.riskList.find((item) => {
        return item.id === params.areaId
      })
      params.areaName = areaObj?.name

      const orgObj = this.departmentList.find((item) => {
        return item.id === params.orgId
      })
      params.orgName = orgObj?.displayName

      const reportPersonOrgObj = this.ownDepartment.find((item) => {
        return item.orgId === params.reportPersonOrgId
      })
      params.reportPersonOrgName = reportPersonOrgObj?.name

      const timeParams = ['violationTime', 'reportTime']
      timeParams.forEach((key) => {
        if (params[key]) {
          params[key] = dayjs(params[key]).format('YYYY-MM-DD HH:mm:ss')
        } else {
          params[key] = null
        }
      })

      const nullParams = ['areaId']
      nullParams.forEach((key) => {
        if (params[key] === '') {
          params[key] = null
        }
      })

      this.$emit('finallySub', params)
    },
    openMenDia() {
      this.showSelectDialog = true
    },
  },
}
</script>
<style lang="scss" scoped></style>
